import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import BangerLogo from "assets/icons/banger/logo-no-icon.svg?react";
import ArrowBackIcon from "assets/icons/glory/arrow-back.svg?react";
import GloryLogo from "assets/icons/glory/glory_logo_mini.svg?react";
import Lottie from "lottie-react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import useTranslate from "hooks/useTranslate";
import { useRouterHistoryStore } from "stores/routerHistory";
import { useGetJWTSportsBookData } from "queries/useGetJWTSportsBook";
import BangerPreloader from "assets/json/banger_game_preloader.json";
import GloryPreloader from "assets/json/glory_game_preloader.json";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import * as authSelectors from "redux/auth/selectors";
import { usePostMessageGR8 } from "hooks/usePostMessageGR8";
import "./styles.sass";

export const SportsBookGamePageMobile = () => {
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  const t = useTranslate();
  const previousPage = useRouterHistoryStore((state) => state.previous);
  const navigate = useNavigate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const { data, isLoading, refetch } = useGetJWTSportsBookData();
  const { event, id } = useParams();

  const urlForIFrame =
    isAuthenticated && data?.token
      ? `https://sport-iframe.pjdoi.xyz/en/${event}/${id}/?jwt=${encodeURIComponent(data.token)}`
      : "https://sport-iframe.pjdoi.xyz/en";

  usePostMessageGR8();

  const preloader =
    VITE_APP_PROJECT_NAME === "banger" ? BangerPreloader : GloryPreloader;
  const handleGoBack = () => {
    navigate(previousPage);
  };

  const handleDeposit = () => {
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.deposit })}`,
    });
  };
  const logo =
    VITE_APP_PROJECT_NAME === "banger" ? <BangerLogo /> : <GloryLogo />;

  const pageClass = classNames("SportsBookGamePageMobile", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });

  useEffect(() => {
    if (isAuthenticated) {
      refetch();
    }
    return () => {
      const iFrame = document.querySelector("iframe");
      if (iFrame && iFrame.contentWindow) {
        iFrame.contentWindow.postMessage(
          {
            type: "iframe",
            value: { logout: true },
          },
          "*",
        );
      }
    };
  }, [isAuthenticated, refetch]);

  return (
    <div className={pageClass}>
      {isLoading ? (
        <div className="SportsBookGamePageMobile__loader">
          <Lottie animationData={preloader} loop={false} />
        </div>
      ) : (
        <iframe
          src={urlForIFrame}
          allowFullScreen
          title="Sports Book"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
      )}

      <div className="SportsBookGamePageMobile__panel">
        <div className="SportsBookGamePageMobile__panel_left">
          <button
            type="button"
            className="SportsBookGamePageMobile__back"
            onClick={handleGoBack}
          >
            <ArrowBackIcon className="SportsBookGamePageMobile__back_icon" />
          </button>
          <div
            className="SportsBookGamePageMobile__logo"
            onClick={handleGoBack}
          >
            {logo}
          </div>
        </div>
        <div className="SportsBookGamePageMobile__panel_right">
          <div className="SportsBookGamePageMobile-deposit">
            <button
              type="button"
              className="SportsBookGamePageMobile-deposit__btn"
              onClick={handleDeposit}
            >
              {t("profile.balance.deposit.title")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
